import { ajaxFunc } from '../tools';
const noticeModule = {
  /****消息中心模块的接口****/

  //消息中心 - 获取消息列表
  notice_list: ajaxFunc('/message/get_messages', 'get', 1),
  //消息中心 - 获取未读消息数
  get_message_count: ajaxFunc('/message/get_message_count', 'get', 1),
  //获取消息详情
  get_messages_detail: ajaxFunc('/message/get_messages_detail', 'get', 1),
  //公告 - 获取列表
  publiNotice_list: ajaxFunc('/nounce/list', 'post', 1),

  //公告 - 获取详情
  publiNotice_detail: ajaxFunc('/nounce/pre', 'post', 1),

  //H5预览 - 获取详情
  h5_detail: ajaxFunc('/nounce/h5Pre', 'post'),
  //我的订单，我的资产列表
  get_messages_list: ajaxFunc('/message/get_messages_list', 'get', 1),

  //新改的消息中心列表
  get_message_count_new: ajaxFunc('/message/get_message_count_new', 'get', 1),

  //新改的消息中心我的订单，我的资产列表
  get_messages_list_new: ajaxFunc('/message/get_messages_list_new', 'post', 1),


  //清除所有未读消息
  clear: ajaxFunc('/message/clear', 'post', 1),

};

export default noticeModule;



// WEBPACK FOOTER //
// ./src/request/api/noticeModule.js